<template>
<div>
  <p>Copy all customers into clipboard and paste them into e.g. Excel or Monday.com.</p>
  <el-button @click="exportCustomersToCSV">
    Copy customers to CSV
  </el-button>
  <el-message success margin-top v-if="customersAreCopied">
    Copied!
  </el-message>
  <el-textarea
    v-if="purchasesAsCSV !== ''"
    v-model="purchasesAsCSV"
    />
</div>
</template>
<script>
export default {
  data () {
    return {
      customersAreCopied: false,
      purchasesAsCSV: ''
    }
  },
  methods: {
    exportCustomersToCSV () {
      const csv = this.$store.getters.purchasesAsCSV

      if (navigator.clipboard) {
        navigator.clipboard.writeText(csv)
        this.customersAreCopied = true
      } else {
        this.purchasesAsCSV = csv
      }
    }
  }
}
</script>
<style lang="less" scoped>

</style>
